import React, { useRef, useEffect } from 'react';

/**
 * InlineCheckbox — Lodgeic DS table checkbox.
 * Serves both row selection and boolean field values.
 * 16×16, orange-400 fill, supports indeterminate (select-all partial).
 */
function InlineCheckbox({ checked, indeterminate = false, onChange, disabled = false, title }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate && !checked;
  }, [indeterminate, checked]);

  const on = checked || (!!indeterminate && !checked);

  return (
    <label
      title={title}
      style={{
        display: 'inline-flex', alignItems: 'center',
        cursor: disabled ? 'default' : 'pointer', userSelect: 'none',
        position: 'relative', width: 16, height: 16, flexShrink: 0,
      }}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={!!checked}
        onChange={onChange || (() => {})}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, inset: 0, cursor: disabled ? 'default' : 'pointer', margin: 0, width: '100%', height: '100%' }}
      />
      <span
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 16, height: 16, borderRadius: 4, pointerEvents: 'none',
          border: `1.5px solid ${on ? 'var(--lodge-orange-400)' : 'var(--lodge-onyx-300)'}`,
          background: on ? 'var(--lodge-orange-400)' : 'var(--lodge-white)',
          transition: 'border-color .1s, background .1s',
          opacity: disabled ? 0.42 : 1,
        }}
      >
        {checked && !indeterminate && (
          <svg width={10} height={8} viewBox="0 0 10 8" fill="none">
            <path d="M1 4l2.5 3L9 1" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
        {indeterminate && !checked && <div style={{ width: 8, height: 1.5, background: 'white', borderRadius: 1 }} />}
      </span>
    </label>
  );
}

export default InlineCheckbox;
